export enum LogActions {
    END_MATERIAL = "END_MATERIAL",
    START_MATERIAL = "START_MATERIAL",
    LOST_ATTENTION = "LOST_ATTENTION",
    RESUME_ATTENTION = "RESUME_ATTENTION",
    ACCESSED = "ACCESSED",
}  